export const CROP_HISTORY_CONFIG = {
  FORM_ID: "crop-history-row-form",
  FIELD_KEY: "Storico colture",
  TITLE: "Storico colture",
  ADD_BUTTON_LABEL: "Aggiungi coltura",
  DESCRIPTION:
    "Ex cupidatat fugiat ad enim sint non. Aute anim ad magna ea elit et sunt...",
  ROW: {
    TITLE: "Coltura",
    DELETE_BUTTON: "Elimina",
    CULTURE_LABEL: "Coltura",
    START_DATE_LABEL: "Data di inizio",
    END_DATE_LABEL: "Data di fine",
    NO_OPTIONS_MESSAGE: "Nessuna opzione disponibile",
    OVERLAP_WARNING:
      "Attenzione: la data si sovrappone con altre già esistenti",
    REQUIRED_CULTURE: "Coltura obbligatoria",
    REQUIRED_START_DATE:
      "Data di inizio obbligatoria quando è selezionata una coltura",
    REQUIRED_END_DATE:
      "Data di fine obbligatoria quando è selezionata una coltura",
  },
};

export const EMPTY_ROW_TEMPLATE = {
  id: null,
  colture: "",
  start_date: null,
  end_date: null,
};

export const FORM_STYLES = {
  FILLED_INPUT: {
    height: "50px",
    backgroundColor: "white",
  },
};
